
















































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { ResearchField, BoardAction as BoardActionEnum } from "@gaia-project/engine";
import ResearchTrack from "./ResearchTrack.vue";
import TechTile from "./TechTile.vue";
import BoardAction from "./BoardAction.vue";

@Component({
  computed: {
    fields(): ResearchField[] {
      return ResearchField.values(this.expansions);
    },
    expansions() {
      return this.$store.state.data.expansions;
    },
    viewWidth() {
      return this.fields.length * 60;
    },
  },
  components: {
    ResearchTrack,
    TechTile,
    BoardAction,
  },
})
export default class ResearchBoard extends Vue {}
